import data from './data'
import methods from './methods'
import validations from './validations'
import components from './components'

export default {
  resourcePath: '/v1/professional/settings/profiles',
  data,
  methods,
  validations,
  components,
  mounted () {
    this.doLoad()
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/record/registration/resources/index.js